import { render, staticRenderFns } from "./tab-sortiment.vue?vue&type=template&id=2c266806&scoped=true"
import script from "./tab-sortiment.vue?vue&type=script&lang=js"
export * from "./tab-sortiment.vue?vue&type=script&lang=js"
import style0 from "./tab-sortiment.vue?vue&type=style&index=0&id=2c266806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c266806",
  null
  
)

export default component.exports